import { render, staticRenderFns } from "./ProposalForm.vue?vue&type=template&id=62a042fe&"
import script from "./ProposalForm.vue?vue&type=script&lang=ts&"
export * from "./ProposalForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProposalForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports